module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av121-303a8b9f633527e2796136cea806ba7d.jpg";